import { ParentTypes } from '@risksmart-app/domain/src/types/consts';

import { t } from '../../i18n-t';
import { getAuditColumns } from './shared';
import type { SharedDataset } from './types';

export const getRiskAssessmentResultImpacts = () =>
  ({
    supportedLatest: true,
    hasAccess: () => true,
    objectType: ParentTypes.RiskAssessmentResultImpact,
    label: 'Risk assessment result impacts',
    fields: {
      ...getAuditColumns(),
      id: {
        dataType: 'guid',
        displayType: 'text',
        defaultLabel: t('columns.guid'),
      },
      label: {
        dataType: 'text',
        displayType: 'text',
        defaultLabel: 'Category',
      },
      value: {
        dataType: 'number',
        displayType: 'rating',
        ratingKey: 'impact',
        defaultLabel: t('assessmentResults.fields.Impact'),
      },
      controlType: {
        dataType: 'text',
        displayType: 'commonLookup',
        i18nKey: 'assessmentResults.controlTypesCased',
        defaultLabel: t('assessmentResults.fields.ControlType'),
      },
    },
  }) as const satisfies SharedDataset;
